import React, { Component } from 'react';
import Logo from '../header/logo';
import NavBar from '../header/navbar';

import { isMobile } from 'react-device-detect';

export class Footer extends Component {
    render() {
        return (
            <footer id="footer" className={isMobile ? 'footer-mobile': '' }>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-3 col-lg-3"><Logo/></div>
                        <div className="col-12 col-md-3 col-lg-9"><NavBar/></div>
                    </div>
                </div>
                <div className="copy">
                    <div className="container">
                        <div className="d-flex justify-content-center"> <i className="fa fa-copyright" aria-hidden="true"></i> Copyright Ideal Brasil. Todos os direitos reservados</div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer
